export default __webpack_public_path__ + "static/media/psychic.a6c9fe6f.svg";